module.exports = __webpack_public_path__ + "static/img/OC_bg03.cde7cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg03.png
// module id = WSuF
// module chunks = 7